import React from 'react';
import history from 'services/history';
import { usePagination } from 'hooks/pagination';
import { AccessRule } from 'types/accessRule';
import DataGridList from 'components/data-grid/DataGridList';
import { accessRulesTableTemplate } from './accessRulesTableTemplate';

type AccessRulesListProps = {
  accessRules: AccessRule[];
};

const AccessRulesList: React.FC<AccessRulesListProps> = ({ accessRules }) => {
  const { page, rowsPerPage } = usePagination();

  return (
    <DataGridList
      template={accessRulesTableTemplate}
      rows={accessRules.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)}
      getRowId={row => row.id as number}
      onRowClick={row => history.push(`/access-rule/${row.id}`)}
      fileName="regras_de_acesso"
      sheetName="Regras de acesso"
    />
  );
};

export default AccessRulesList;
